import { useState } from "react";
import { supabase } from "./supabase";

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    setError("");
    setLoading(true);
    let result;
    if (mode === "login") {
      result = await supabase.auth.signInWithPassword({ email, password });
    } else {
      result = await supabase.auth.signUp({ email, password });
    }
    if (result.error) setError(result.error.message);
    setLoading(false);
  };

  return (
    <div style={{
      display:"flex", alignItems:"center", justifyContent:"center",
      height:"100vh", background:"#0F1117", fontFamily:"Inter, sans-serif"
    }}>
      <div style={{
        background:"#1A1F2E", borderRadius:16, padding:"40px 36px",
        width:"100%", maxWidth:400, boxShadow:"0 20px 60px rgba(0,0,0,0.4)"
      }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:32 }}>
          <div style={{ width:40, height:40, borderRadius:10, background:"linear-gradient(135deg,#2563EB,#7C3AED)", display:"flex", alignItems:"center", justifyContent:"center" }}>
            <span style={{ fontSize:18 }}>💰</span>
          </div>
          <div>
            <div style={{ fontWeight:800, fontSize:16, color:"#FFFFFF" }}>FinanceOS</div>
            <div style={{ fontSize:11, color:"rgba(255,255,255,0.35)", fontWeight:600, letterSpacing:"0.10em" }}>PERSONAL ACCOUNTING</div>
          </div>
        </div>

        <h2 style={{ color:"#fff", fontSize:20, fontWeight:700, marginBottom:8 }}>
          {mode === "login" ? "Welcome back" : "Create account"}
        </h2>
        <p style={{ color:"rgba(255,255,255,0.4)", fontSize:13, marginBottom:28 }}>
          {mode === "login" ? "Sign in to your account" : "Sign up for FinanceOS"}
        </p>

        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:12, color:"rgba(255,255,255,0.5)", fontWeight:500, display:"block", marginBottom:6 }}>Email</label>
          <input
            type="email" value={email} onChange={e=>setEmail(e.target.value)}
            placeholder="you@example.com"
            style={{ width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px solid rgba(255,255,255,0.1)", background:"rgba(255,255,255,0.05)", color:"#fff", fontSize:14, outline:"none", boxSizing:"border-box" }}
          />
        </div>

        <div style={{ marginBottom:24 }}>
          <label style={{ fontSize:12, color:"rgba(255,255,255,0.5)", fontWeight:500, display:"block", marginBottom:6 }}>Password</label>
          <input
            type="password" value={password} onChange={e=>setPassword(e.target.value)}
            placeholder="••••••••"
            onKeyDown={e=>e.key==="Enter"&&handle()}
            style={{ width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px solid rgba(255,255,255,0.1)", background:"rgba(255,255,255,0.05)", color:"#fff", fontSize:14, outline:"none", boxSizing:"border-box" }}
          />
        </div>

        {error && <div style={{ color:"#F87171", fontSize:13, marginBottom:16, background:"rgba(248,113,113,0.1)", padding:"10px 14px", borderRadius:8 }}>{error}</div>}

        <button
          onClick={handle} disabled={loading}
          style={{ width:"100%", padding:"12px", borderRadius:8, border:"none", background:"linear-gradient(135deg,#2563EB,#7C3AED)", color:"#fff", fontSize:14, fontWeight:600, cursor:"pointer", opacity:loading?0.7:1 }}
        >
          {loading ? "Please wait..." : mode === "login" ? "Sign In" : "Sign Up"}
        </button>

        <p style={{ textAlign:"center", marginTop:20, fontSize:13, color:"rgba(255,255,255,0.4)" }}>
          {mode === "login" ? "Don't have an account? " : "Already have an account? "}
          <span onClick={()=>{setMode(mode==="login"?"signup":"login");setError("");}} style={{ color:"#60A5FA", cursor:"pointer", fontWeight:600 }}>
            {mode === "login" ? "Sign up" : "Sign in"}
          </span>
        </p>
      </div>
    </div>
  );
}